module.exports = __webpack_public_path__ + "static/media/firebase.e9832556.png";